var map = {
	"./ActivityCard.component": 9717,
	"./ActivityCard.component.js": 9717,
	"./AddAvatarDialog.component": 2248,
	"./AddAvatarDialog.component.js": 2248,
	"./AddFoodForm.component": 9080,
	"./AddFoodForm.component.js": 9080,
	"./AddImageDialog.component": 8674,
	"./AddImageDialog.component.js": 8674,
	"./Avatar.components": 6978,
	"./Avatar.components.js": 6978,
	"./Buttons.components": 4435,
	"./Buttons.components.js": 4435,
	"./ChangeAvatarDialog.component": 4882,
	"./ChangeAvatarDialog.component.js": 4882,
	"./ChangeImageDialog.component": 6130,
	"./ChangeImageDialog.component.js": 6130,
	"./ChartPie.components": 3102,
	"./ChartPie.components.js": 3102,
	"./Checkbox.component": 2149,
	"./Checkbox.component.js": 2149,
	"./CustomAlert.component": 4745,
	"./CustomAlert.component.js": 4745,
	"./CustomDatePicker.component": 6304,
	"./CustomDatePicker.component.js": 6304,
	"./CustomDatePickerWithArrows.component": 8498,
	"./CustomDatePickerWithArrows.component.js": 8498,
	"./EditFoodForm.component": 180,
	"./EditFoodForm.component.js": 180,
	"./FoodCard.component": 7441,
	"./FoodCard.component.js": 7441,
	"./FoodImage.components": 2299,
	"./FoodImage.components.js": 2299,
	"./Form.components": 2265,
	"./Form.components.js": 2265,
	"./Image.components": 2059,
	"./Image.components.js": 2059,
	"./ImageCircle.components": 3527,
	"./ImageCircle.components.js": 3527,
	"./LoadingAndError.components": 442,
	"./LoadingAndError.components.js": 442,
	"./LoginForm.components": 6503,
	"./LoginForm.components.js": 6503,
	"./MealCard.component": 3262,
	"./MealCard.component.js": 3262,
	"./NavBar.component": 1434,
	"./NavBar.component.js": 1434,
	"./NewActivityForm.component": 6506,
	"./NewActivityForm.component.js": 6506,
	"./NewFoodForm.component": 3607,
	"./NewFoodForm.component.js": 3607,
	"./NewTrainingForm.component": 9749,
	"./NewTrainingForm.component.js": 9749,
	"./PageContainer.component": 2851,
	"./PageContainer.component.js": 2851,
	"./ProfileForm.component": 4833,
	"./ProfileForm.component.js": 4833,
	"./RegisterForm.component": 8103,
	"./RegisterForm.component.js": 8103,
	"./Spinner.components": 4177,
	"./Spinner.components.js": 4177,
	"./Statistic.components": 2355,
	"./Statistic.components.js": 2355,
	"./StatisticBarChart.component": 4390,
	"./StatisticBarChart.component.js": 4390,
	"./Swipe.components.tsx": 6787,
	"./TabBar.component": 4528,
	"./TabBar.component.js": 4528,
	"./TrainingCard.component": 2534,
	"./TrainingCard.component.js": 2534,
	"./assets/activity_fetch.svg": 2631,
	"./assets/activity_run.svg": 3899,
	"./assets/activity_swim.svg": 2942,
	"./assets/activity_tab_icon_unselected.svg": 3868,
	"./assets/activity_walk.svg": 5329,
	"./assets/add_avatar_placeholder_green.png": 1572,
	"./assets/add_avatar_placeholder_orange.png": 4710,
	"./assets/add_black.svg": 5482,
	"./assets/add_food_placeholder_green.png": 4155,
	"./assets/add_food_placeholder_orange.png": 3273,
	"./assets/add_green.svg": 4561,
	"./assets/add_orange.svg": 9808,
	"./assets/add_profile.svg": 136,
	"./assets/add_round_black.svg": 5055,
	"./assets/add_round_green.svg": 5069,
	"./assets/add_round_orange.svg": 4899,
	"./assets/add_round_white.svg": 134,
	"./assets/add_white.svg": 8430,
	"./assets/arrow_down_black.svg": 8943,
	"./assets/arrow_down_green.svg": 9500,
	"./assets/arrow_down_orange.svg": 9384,
	"./assets/arrow_left_black.svg": 3529,
	"./assets/arrow_left_green.svg": 9153,
	"./assets/arrow_left_orange.svg": 9907,
	"./assets/arrow_right_black.svg": 4417,
	"./assets/arrow_right_green.svg": 1108,
	"./assets/arrow_right_orange.svg": 5382,
	"./assets/arrow_up_black.svg": 1403,
	"./assets/arrow_up_green.svg": 1959,
	"./assets/arrow_up_orange.svg": 6093,
	"./assets/avatar_placeholder.png": 8980,
	"./assets/avatar_small_placeholder.png": 9229,
	"./assets/back_arrow.svg": 5065,
	"./assets/bones.png": 5793,
	"./assets/calories.png": 1244,
	"./assets/cancel_black.svg": 8916,
	"./assets/cancel_green.svg": 8686,
	"./assets/cancel_orange.svg": 669,
	"./assets/cancel_white.svg": 5507,
	"./assets/change_profile.svg": 1962,
	"./assets/checkmark_black.svg": 1867,
	"./assets/checkmark_green.svg": 5792,
	"./assets/checkmark_orange.svg": 9957,
	"./assets/checkmark_white.svg": 3113,
	"./assets/close_round_black.svg": 3345,
	"./assets/close_round_green.svg": 9709,
	"./assets/close_round_orange.svg": 1879,
	"./assets/close_round_white.svg": 511,
	"./assets/copy_black.svg": 9639,
	"./assets/copy_green.svg": 4559,
	"./assets/copy_orange.svg": 5428,
	"./assets/copy_white.svg": 96,
	"./assets/dashboard_tab_icon_selected.png": 484,
	"./assets/dashboard_tab_icon_unselected.png": 735,
	"./assets/dashboard_tab_icon_unselected.svg": 329,
	"./assets/delete_account.svg": 2483,
	"./assets/delete_black.svg": 1601,
	"./assets/delete_green.svg": 1575,
	"./assets/delete_orange.svg": 5960,
	"./assets/delete_white.svg": 5663,
	"./assets/diary_tab_icon_unselected.svg": 990,
	"./assets/dog_sit.png": 1358,
	"./assets/dryFood.png": 6334,
	"./assets/edit_black.svg": 9290,
	"./assets/edit_green.svg": 9810,
	"./assets/edit_orange.svg": 3369,
	"./assets/edit_white.svg": 5655,
	"./assets/fiber.png": 9246,
	"./assets/fish.png": 2553,
	"./assets/food_placeholder.png": 4532,
	"./assets/fruits.png": 1412,
	"./assets/general_error.png": 3963,
	"./assets/giblets.png": 7049,
	"./assets/health_tab_icon_unselected.svg": 3317,
	"./assets/hide_password.svg": 3034,
	"./assets/liver.png": 1008,
	"./assets/logo.png": 5886,
	"./assets/logo_green_stroke.png": 7779,
	"./assets/logout_tab_icon_unselected.svg": 3282,
	"./assets/meat.png": 7102,
	"./assets/minus_round_button.svg": 2079,
	"./assets/more_black.svg": 3864,
	"./assets/more_green.svg": 4686,
	"./assets/more_orange.svg": 883,
	"./assets/more_tab_icon_unselected.svg": 7243,
	"./assets/more_white.svg": 8996,
	"./assets/no_activities_placeholder.png": 8106,
	"./assets/no_chart_placeholder.png": 8891,
	"./assets/no_data_placeholder.png": 6224,
	"./assets/no_food_placeholder.png": 6879,
	"./assets/no_meals_placeholder.png": 5627,
	"./assets/no_percentage_placeholder.png": 461,
	"./assets/no_results_placeholder.png": 9677,
	"./assets/no_trainings_placeholder.png": 4688,
	"./assets/no_weights_placeholder.png": 5309,
	"./assets/other.png": 3861,
	"./assets/paw_white.png": 3580,
	"./assets/plus_round_button.svg": 520,
	"./assets/plus_round_fill_button.svg": 5053,
	"./assets/plus_round_fill_white_button.svg": 7630,
	"./assets/recipe.png": 8132,
	"./assets/save_black.svg": 6095,
	"./assets/save_green.svg": 2845,
	"./assets/save_orange.svg": 4657,
	"./assets/save_white.svg": 3308,
	"./assets/seeds.png": 6073,
	"./assets/show_password.svg": 9597,
	"./assets/spinner/activity_indicator1.png": 81,
	"./assets/spinner/activity_indicator2.png": 6521,
	"./assets/spinner/activity_indicator3.png": 1609,
	"./assets/spinner/activity_indicator4.png": 7290,
	"./assets/spinner/activity_indicator5.png": 7092,
	"./assets/start_typing_placeholder.png": 5875,
	"./assets/stat_placeholder.png": 1155,
	"./assets/suplements.png": 2242,
	"./assets/training_custom.svg": 9722,
	"./assets/training_items.svg": 6869,
	"./assets/training_obedience.svg": 875,
	"./assets/training_potty.svg": 4902,
	"./assets/training_social.svg": 4775,
	"./assets/training_sounds.svg": 312,
	"./assets/training_tab_icon_unselected.svg": 4479,
	"./assets/treat.png": 1467,
	"./assets/trophy.svg": 2286,
	"./assets/veggie.png": 6136,
	"./assets/wetFood.png": 3406,
	"./styles/Activity.css": 3105,
	"./styles/Activity.css.js": 3105,
	"./styles/AddFood.css": 5600,
	"./styles/AddFood.css.js": 5600,
	"./styles/AddFoodCard.css": 7596,
	"./styles/AddFoodCard.css.js": 7596,
	"./styles/Colors": 5783,
	"./styles/Colors.js": 5783,
	"./styles/CreateNewActivity.css": 7882,
	"./styles/CreateNewActivity.css.js": 7882,
	"./styles/CreateNewFood.css": 9347,
	"./styles/CreateNewFood.css.js": 9347,
	"./styles/CreateNewTraining.css": 707,
	"./styles/CreateNewTraining.css.js": 707,
	"./styles/Dashboard.css": 769,
	"./styles/Dashboard.css.js": 769,
	"./styles/Home.css": 9780,
	"./styles/Home.css.js": 9780,
	"./styles/Login.css": 5290,
	"./styles/Login.css.js": 5290,
	"./styles/Meals.css": 4402,
	"./styles/Meals.css.js": 4402,
	"./styles/Media-queries": 9011,
	"./styles/Media-queries.js": 9011,
	"./styles/More.css": 2544,
	"./styles/More.css.js": 2544,
	"./styles/NavBar.css": 2801,
	"./styles/NavBar.css.js": 2801,
	"./styles/Profile.css": 527,
	"./styles/Profile.css.js": 527,
	"./styles/SearchFood.css": 7165,
	"./styles/SearchFood.css.js": 7165,
	"./styles/Training.css": 5681,
	"./styles/Training.css.js": 5681,
	"./styles/styles.css": 7286,
	"./styles/swiper.css": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 744;